import { render, staticRenderFns } from "./DeliverForm.vue?vue&type=template&id=683298f4&scoped=true&"
import script from "./DeliverForm.vue?vue&type=script&lang=js&"
export * from "./DeliverForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliverForm.vue?vue&type=style&index=0&id=683298f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683298f4",
  null
  
)

export default component.exports